import styled from "styled-components";

const PromoContainer = styled.div`
  background: rgb(255, 255, 255);
  overflow: hidden;
  height: 328px;
  border-radius: 0px 24px;
  position: relative;
`;

const Div = styled.div`
  padding: 0px;
  width: 100%;
  border-radius: 0px 24px;
`;

const Img = styled.img`
  width: 100%;
  object-fit: cover;
`;

const Overlay = styled.div`
  position: absolute;
  width: 100%;
  height: 328px;
  left: 0px;
  right: 0px;
  top: 0px;
  background: linear-gradient(rgba(94, 81, 77, 0) 0%, rgb(94, 81, 77) 100%);
  border-radius: 0px 24px;
`;

const Title = styled.h3`
  position: absolute;
  width: 312px;
  height: 40px;
  left: 24px;
  top: 201px;
  font-family: KBFGDisplay;
  font-style: normal;
  font-weight: bold;
  font-size: 16px;
  line-height: 24px;
  color: rgb(255, 255, 255);
`;

const Text = styled.p`
  position: absolute;
  width: 312px;
  height: 40px;
  left: 24px;
  top: 264px;
  font-family: KBFGText;
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 20px;
  color: rgb(255, 255, 255);
`;

const CardPromo = ({ title, src, text }) => {
  return (
    <PromoContainer className="mx-0 mb-3">
      <Div className="m-0">
        <Img src={src} alt={title}></Img>
        <Overlay></Overlay>
      </Div>
      <Title>{title}</Title>
      <Text>{text}</Text>
    </PromoContainer>
  );
};

export default CardPromo;
